import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje } from '../components/mensajes';
import { Loader, Dimmer } from 'semantic-ui-react';
import useTable from '../components/useTable';
import { TableBody, TableRow, TableCell } from '@material-ui/core';
import axios from "axios";
import { formatMoneda } from '../util/varios';
import moment from 'moment';

const CatalogoFacturasdCompra = props => {

    let op = require('../../public/modulos/datos');
    let token = sessionStorage.getItem('jwtToken');
    const btnAcepta = useRef();
    const btnCancela = useRef();
    const txtBuscar = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [activo, setActivo] = useState(true);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({
        idpedido: '',
        numpedido: ''
    });
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'N° FACTURA', textAlign: 'center' },
        { label: 'CEDULA/RIF', textAlign: 'center' },
        { label: 'NOMBRE', textAlign: 'center' },
        { label: 'FECHA', textAlign: 'center' },
        { label: 'ESTATUS', textAlign: 'center' }
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.numfactura.toLowerCase().includes(target.value.toLowerCase())
                            || moment(x.fechafactura).format('DD/MM/YYYY').toLowerCase().includes(target.value.toLowerCase())
                            || x.nombre.toLowerCase().includes(target.value.toLowerCase())
                            || x.cedularif.toLowerCase().includes(target.value.toLowerCase())
                            || (x.status !== 4 ? 'PROCESADA' : 'ANULADA').toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarRegistros = () => {

        let campos = 'idfacturacompra, numfactura, fechafactura, nombre, cedularif, status';
        let condicion = props.condicion;
        let nomtab = 'facturacompra';
        let endpoint = `${op.conexion}/api/retenciones/catalogofacturascompra?campos=${campos}&condicion=${condicion}&nomtab=${nomtab}`;

        setActivate(true);

        axios.get(endpoint, {
            headers: {
                'x-access-token': `${token}`
            }
        }).then(function (response) {

            if (response.status === 200) {
                if (response.data.length > 0) {
                    setRecords(response.data);
                }
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        }).finally(() => {
            setActivate(false);
        })

    }


    const blanquear = () => {
        setItemSelect("");
        setActivate(false);
        setActivo(true);
        setRecords([]);
        setValues({
            idfacturacompra: '',
            numfactura: ''
        });
        setFilterFn({ fn: items => { return items; } });
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }


    const seleccionarProducto = () => {

        props.onHideAceptaCatalogo(values);

    };

    const seleccionarFila = (item) => (e) => {
        e.preventDefault();
        setActivo(false);
        setValues({
            idfacturacompra: item.idfacturacompra,
            numfactura: item.numfactura
        });
        btnAcepta.current.focus();
    };

    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                blanquear();
                seleccionarRegistros();
                txtBuscar.current.focus();
            }}
        >
            <Modal.Header className='azulGradiant2 header-modal'>
                <div className="fw-bold text-light"><h3>Seleccionar Factura de Compra</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>
                    <Loader inverted>Cargando...</Loader>
                </Dimmer>
                <div className="col-md-12" style={{ marginBottom: "10px" }}>
                    <div className="row">
                        <div className="input-group col-md-8 input-group-sm mb-3">
                            <input type='text'
                                onChange={handleSearch} ref={txtBuscar} className="form-control border-azul border-2 text-uppercase" />
                            <button className='btn btn-info' style={{ pointerEvents: 'none' }}><i className='fa fa-search'></i></button>
                        </div>
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <TableBody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <TableRow key={index} style={{ padding: "0", cursor: 'pointer', background: values.idfacturacompra === item.idfacturacompra ? "lightskyblue" : "white" }} onClick={seleccionarFila(item)}>
                                        <TableCell className='py-2 text-center'>{item.numfactura}</TableCell>
                                        <TableCell className='py-2 text-center'>{item.cedularif}</TableCell>
                                        <TableCell className='py-2 text-start'>{item.nombre}</TableCell>
                                        <TableCell className='py-2 text-center'>{moment(item.fechafactura).format('DD/MM/YYYY')}</TableCell>
                                        <TableCell className={item.status !== 4 ? 'py-2 text-center text-bold' : 'py-2 text-center text-danger text-bold'}>{item.status !== 4 ? 'PROCESADA' : 'ANULADA'}</TableCell>
                                    </TableRow>

                                ))
                            }
                        </TableBody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} disabled={activo} className="btn btn-sm btn-success rounded-pill" style={{ margin: "5px" }} onClick={seleccionarProducto}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoFacturasdCompra;


// WEBPACK FOOTER //
// ./src/catalogos/catalogoFacturasCompra.js